import React, { useRef, useEffect, useState } from 'react';
import { ReactComponent as PdfIcon } from '../../assets/icons/pdf.svg';
import { ReactComponent as CrossIcon } from '../../assets/icons/cross.svg';
import DocumentsList from '../DocumentsList/DocumentsList';
import Button from '../Button/Button';
import { isPrestataireRole, isClientRole } from '../../utils/roleUtils';
import { useAuth } from '../../contexts/AuthContext';
import YousignIframe from '../YousignIframe/YousignIframe';
import './Marche.css'
import { useNavigate } from 'react-router-dom';


interface MarcheProps {
  operation?: any;
  commande?: any;
  selectedPrestataire: number | null;
}

function Modal({ children, isOpen, handleClose, closeButton }) {
  // 👇 L'usage de cet ref va particulièrement nous intéresser 
  const dialogRef = useRef<HTMLDialogElement>(null);

  const close = () => {
    dialogRef.current?.close();
  };

  function handleClickOutside(event) {
    if (!dialogRef.current || !closeButton) {
      return;
    }

    const box = dialogRef.current?.getBoundingClientRect();
    // On calcule si le curseur est à l'extérieur de la boîte englobante de la modale
    if (
      event.pageX < box.left ||
      event.pageX > box.right ||
      event.pageY < (box.top + window.scrollY) ||
      event.pageY > (box.bottom + window.scrollY)
    ) {
      close();
    }
  }

  useEffect(() => {
    const dialog = dialogRef.current;
    if (isOpen && !dialogRef.current?.open) {
      dialog?.showModal(); // 👈 usage propre à l'élément <dialog>
    } else {
      dialog?.close(); // 👈 usage propre à l'élément <dialog>
    }
  }, [isOpen]);

  return (
    <dialog
      ref={dialogRef}
      onClose={handleClose}
      onClick={handleClickOutside}
      className="ys-modal-dialog"
    >
      {children}

      {closeButton && (
        <Button
          type="button"
          onClick={close}
          value="Fermer"
          aria-label="Fermer"
          size='small'
          className="ys-modal-close-button"
        />
      )}
    </dialog>
  );
}

const Marche: React.FC<MarcheProps> = ({
  operation,
  commande,
  selectedPrestataire
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = (() => {
    setIsOpen(false);
  });

  const handleClick = (() => {
    setIsOpen(true);
  });

  const { user } = useAuth();
  console.log(operation)


  let selectedPresta: any = null;

  if (user) {


    if (isPrestataireRole(user.role)) {
      // côté prestataire : on reçoit directement une commande
      selectedPresta = commande ?? null;
    } else if (isClientRole(user.role)) {
      const commandes = operation?.commandes || [];
      selectedPresta = commandes[selectedPrestataire ?? 0] ?? null;
    }
  }

  // Adresse (protégée avec ?.)
  const prestaAdress = selectedPresta?.contrat?.entite?.adresse
    ? `${selectedPresta.contrat.entite.adresse.numero_voie || ''} ${selectedPresta.contrat.entite.adresse.type_voie || ''} ${selectedPresta.contrat.entite.adresse.nom_voie || ''}, ${selectedPresta.contrat.entite.adresse.code_postal || ''} ${selectedPresta.contrat.entite.adresse.ville || ''}`
    : '';

  console.log("user", user);
  console.log("selectedPresta", selectedPresta);
  console.log("operation", operation);
  console.log("commande", commande);
  const isPresta = isPrestataireRole(user?.role ?? "null");
  const isAcheteur = isClientRole(user?.role ?? "null");
  const external_id = isAcheteur ? operation?.id?.toString() : isPresta ? commande?.operation?.id?.toString() : "";
  const operationStatus = operation?.status?.id ?? null;
  const commandeStatus = commande?.status?.id ?? null;
  const navigate = useNavigate();
  const [showRedirectModal, setShowRedirectModal] = useState(false);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if ((isAcheteur && operationStatus < 7) || (isPresta && commandeStatus < 10)) {
      setShowRedirectModal(true);
      setCountdown(5);

      const interval = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isAcheteur, isPresta, operationStatus, commandeStatus]);

  useEffect(() => {
    if (countdown <= 0 && showRedirectModal) {
      navigate(isAcheteur ? '/operations' : '/commandes', { replace: true });
    }
  }, [countdown, showRedirectModal, navigate, isAcheteur]);



  return (
    <>
      <Modal isOpen={showRedirectModal} handleClose={() => setShowRedirectModal(false)} closeButton={false}>
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: '1.75rem' }}>
          <h3 style={{ fontWeight: 'bold', fontSize: '2rem', marginBottom: '1rem' }}>Accès interdit</h3>
          <p>Vous n'avez pas accès à cette page. Vous allez être redirigé dans {countdown} secondes...</p>
        </div>
      </Modal>
      <div className="tab-marche">
        {/* Section 1: Signature du marché */}
        <section>
          <h3 className='section-header'>Signature du marché</h3>
          <div className="section-content">
            {/* Signature en cours */}
            {((isAcheteur && operationStatus === 7) || (isPresta && commandeStatus === 10)) && (
              <div className="signature-pending">
                <h4>Signature électronique du marché</h4>
                <p>La signature électronique est réalisée via notre partenaire Yousign.</p>

                {/* Iframe pour intégrer Yousign */}
                <div className="yousign-iframe-container">
                  <Modal
                    isOpen={isOpen}
                    handleClose={handleClose}
                    closeButton
                  >
                    <YousignIframe external_id={external_id} external_type='operation' />
                  </Modal>

                  <Button
                    type="button"
                    onClick={handleClick}
                    value="Signer le marché"
                  />
                </div>

                {/* Message d'instructions */}
                <div className="signature-instructions">
                  <p>Veuillez suivre les instructions dans le cadre ci-dessus pour signer électroniquement le marché.</p>
                  <p>En cas de problème, contactez le support.</p>
                </div>
              </div>
            )}
            {/* En attente de signature prestataire */}
            {(isAcheteur && operationStatus === 9) && (
              <div className="signature-prestataire-en-cours">
                <div className="signature-pending">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <h4>Votre signature est prise en compte</h4>
                  <p>Le prestataire doit maintenant signer le marché. Vous serez notifié une fois cette étape terminée et pourrez alors télécharger les documents.</p>
                </div>
              </div>
            )}
            {/* Marché signé et validé par les deux parties */}
            {((isAcheteur && operationStatus === 11) || (isPresta && commandeStatus === 11)) && (
              <div className="signature-complete">
                <div className="signature-success">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <h4>Marché signé électroniquement</h4>
                  <p style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                    Le marché a été signé par toutes les parties le{" "}
                    {isAcheteur
                      ? new Intl.DateTimeFormat("fr-FR", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      }).format(new Date(operation?.updated_at))
                      : new Intl.DateTimeFormat("fr-FR", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      }).format(new Date(commande?.updated_at))}
                  </p>
                </div>
                <div className="document-actions">
                  <Button
                    value="Télécharger l'acte d'engagement signé"
                    variant="secondary"
                    icon={<PdfIcon />}
                    onClick={() => console.log('Télécharger acte d\'engagement')}
                  />
                  <Button
                    value="Télécharger l'attestation de signature"
                    variant="secondary"
                    icon={<PdfIcon />}
                    onClick={() => console.log('Télécharger attestation')}
                  />
                </div>
              </div>
            )}
          </div >
        </section >

        {/* Section 2: Coordonnées */}
        < section >
          <h3 className='section-header'>Coordonnées</h3>
          <div className="section-content coordinates-section">
            <div className="coordinates-columns">
              <div className="coordinates-column">
                <h4>{selectedPresta?.contrat?.entite?.nom ?? commande?.contrat?.entite?.nom}</h4>
                {isAcheteur ? (
                  <div className="details-block">
                    <p>{prestaAdress}</p>
                    <p>
                      {/* SIRET : {operation.commandes[selectedPrestataire !== null ? selectedPrestataire : 0].siret || "65789765434567"}  */}
                      {/* -  */}
                      Contrat N°{selectedPresta?.contrat?.numero || "25-456"}</p>
                    <p>Lot : {selectedPresta?.contrat?.lot_technique?.id || "212 - Multiservice et performances énergétiques"} - {selectedPresta?.contrat?.lot_technique?.nom}, {(selectedPresta?.contrat?.lot_departement?.departement?.id || 38).toString().padStart(2, "0")} {"(" + selectedPresta?.contrat?.lot_departement?.departement?.nom + ")" || "(Isère)"}</p>

                    <p className="section-separator">Prestataire : {selectedPresta?.contrat?.entite?.interlocuteur?.prenom ?? ''} {selectedPresta?.contrat?.entite?.interlocuteur?.nom || "John SMITH"}</p>
                    <p>{selectedPresta?.contrat?.entite?.interlocuteur?.fonction || "Chef de chantier"}</p>
                    <p>{selectedPresta?.contrat?.entite?.interlocuteur?.email_contact || "sophie.martin@eiffage.fr"}</p>
                    <p>{selectedPresta?.contrat?.entite?.interlocuteur?.telephone || "06 78 98 09 98"}</p>

                    <p className="section-separator">Prestataire signataire : {selectedPresta?.prestataire_signataire?.prenom} {selectedPresta?.prestataire_signataire?.nom}</p>
                    <p>{selectedPresta?.prestataire_signataire?.fonction || "Directeur"}</p>
                    <p>{selectedPresta?.prestataire_signataire?.email_contact || "sophie.martin@eiffage.fr"}</p>
                    <p>{selectedPresta?.prestataire_signataire?.telephone || "06 78 98 09 98"}</p>
                  </div>
                ) : isPresta ? (
                  <div className="details-block">
                    <p>{prestaAdress}</p>
                    <p>
                      {/* SIRET : {operation.commandes[selectedPrestataire !== null ? selectedPrestataire : 0].siret || "65789765434567"}  */}
                      {/* -  */}
                      Contrat N°{commande?.contrat?.numero || "25-456"}</p>
                    <p>Lot : {commande?.operation?.lot_technique?.id || "212 - Multiservice et performances énergétiques"} - {commande?.operation?.lot_technique?.nom}, {(commande?.operation?.lot_departement?.departement?.id || 38).toString().padStart(2, "0")} {"(" + commande?.operation?.lot_departement?.departement?.nom + ")" || "(Isère)"}</p>

                    <p className="section-separator">Prestataire : {commande?.contrat?.entite?.interlocuteur?.prenom ?? ''} {selectedPresta?.contrat?.entite?.interlocuteur?.nom || "John SMITH"}</p>
                    <p>{commande?.contrat?.entite?.interlocuteur?.fonction || "Chef de chantier"}</p>
                    <p>{commande?.contrat?.entite?.interlocuteur?.email_contact || "sophie.martin@eiffage.fr"}</p>
                    <p>{commande?.contrat?.entite?.interlocuteur?.telephone || "06 78 98 09 98"}</p>

                    <p className="section-separator">Prestataire signataire : {commande?.prestataire_signataire.prenom} {commande?.prestataire_signataire.nom}</p>
                    <p>{commande?.prestataire_signataire.fonction || "Directeur"}</p>
                    <p>{commande?.prestataire_signataire.email_contact || "sophie.martin@eiffage.fr"}</p>
                    <p>{commande?.prestataire_signataire.telephone || "06 78 98 09 98"}</p>
                  </div>
                ) : (
                  <div className="empty-details">
                    <p>Aucun prestataire sélectionné pour ce marché.</p>
                  </div>
                )}
              </div>

              <div className="coordinates-column">
                <h4>{operation?.organisme?.nom || commande?.operation?.organisme?.nom}</h4>
                {isAcheteur ? (
                  <div className="details-block">
                    <p>{operation.organisme.adresse.numero_voie} {operation.organisme.adresse.type_voie} {operation.organisme.adresse.nom_voie}, {operation.organisme.adresse.code_postal} {operation.organisme.adresse.ville} {operation.organisme.adresse.arrondissement}</p>

                    <p className="section-separator">Acheteur : {operation.organisme.acheteur.prenom || "Sophie MARTIN"} {operation.organisme.acheteur.nom}</p>
                    <p>{operation.organisme.acheteur.fonction || "Chef de service"}</p>
                    <p>{operation.organisme.acheteur.email_contact || "sophie.martin@eiffage.fr"}</p>
                    <p>{operation.organisme.acheteur.telephone || "06 78 98 09 98"}</p>

                    <p className="section-separator">Acheteur signataire : {operation.acheteur_signataire?.prenom || ''} {operation.acheteur_signataire?.nom || operation.contact || "Sophie MARTIN"}</p>
                    <p>{operation.acheteur_signataire?.fonction || "Directeur"}</p>
                    <p>{operation.acheteur_signataire?.email_contact || operation.email || "sophie.martin@eiffage.fr"}</p>
                    <p>{operation.acheteur_signataire?.telephone || operation.telephone || "06 78 98 09 98"}</p>

                    <p className="section-separator">Facturation suivie par : {operation.organisme.facturation || "-"}</p>
                  </div>
                ) : isPresta ? (
                  <>
                    <div className="details-block">
                      <p>
                        {commande?.operation?.organisme?.adresse?.numero_voie}{" "}
                        {commande?.operation?.organisme?.adresse?.type_voie}{" "}
                        {commande?.operation?.organisme?.adresse?.nom_voie},{" "}
                        {commande?.operation?.organisme?.adresse?.code_postal}{" "}
                        {commande?.operation?.organisme?.adresse?.ville}{" "}
                        {commande?.operation?.organisme?.adresse?.arrondissement}
                      </p>

                      <p className="section-separator">
                        Acheteur : {commande?.operation?.acheteur?.prenom || "Sophie MARTIN"}{" "}
                        {commande?.operation?.acheteur?.nom}
                      </p>
                      <p>{commande?.operation?.acheteur?.fonction || "Chef de service"}</p>
                      <p>{commande?.operation?.acheteur?.email_contact || "sophie.martin@eiffage.fr"}</p>
                      <p>{commande?.operation?.acheteur?.telephone || "06 78 98 09 98"}</p>

                      <p className="section-separator">
                        Acheteur signataire : {commande?.operation?.acheteur_signataire.prenom || ''}{" "}
                        {commande?.operation?.acheteur_signataire.nom || commande?.operation?.contact || "Sophie MARTIN"}
                      </p>
                      <p>{commande?.operation?.acheteur_signataire.fonction || "Directeur"}</p>
                      <p>{commande?.operation?.acheteur_signataire.email_contact || commande?.operation?.email || "sophie.martin@eiffage.fr"}</p>
                      <p>{commande?.operation?.acheteur_signataire.telephone || commande?.operation?.telephone || "06 78 98 09 98"}</p>

                      <p className="section-separator">
                        Facturation suivie par : {commande?.operation?.facturation || "-"}
                      </p>
                    </div>
                  </>
                ) : (
                  <div className="empty-details">
                    <p>Informations client non disponibles.</p>
                  </div>
                )}
              </div>
            </div>

            <div className="documents-section">
              <DocumentsList
                documents={[
                  { id: '1', name: 'Acte d\'engagement', type: 'document', dateUpload: '10/01/2023', status: 'Signé' },
                  { id: '2', name: 'CCAP', type: 'document', dateUpload: '10/01/2023', status: 'Disponible' },
                  { id: '3', name: 'CCTP', type: 'document', dateUpload: '10/01/2023', status: 'Disponible' }
                ]}
                onDownload={(doc) => console.log('Télécharger', doc.name)}
                onView={(doc) => console.log('Voir', doc.name)}
              />
            </div>
          </div >
        </section >
      </div >
    </>
  );
};

export default Marche;